// extracted by mini-css-extract-plugin
module.exports = {"container":"_2PzLULZ3FTuz147zWaZoPE","groupsList":"hkshzgDZyLl6jEaQ2toUt"};